import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';

@Component({
  selector: 'tt-prod-grp3-menu',
  templateUrl: './prod-grp3-menu.component.html',
  styleUrls: ['./prod-grp3-menu.component.css']
})
export class ProdGrp3MenuComponent implements OnInit {
    prodGrp3Id;

    public menu?: Menu;

    public grid?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.prodGrp3Id = this.stateService.getStateParams()['prodgrp3_id'];
    }

    private async loadMenu() {
        if (!!this.prodGrp3Id) {
            this.menu = (await this.datatask.Post(3078, { prodgrp3_id: this.prodGrp3Id }))[0];
        }
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_prodgrp3menu_prodgrp4_grid')
                .setLoadDataFunction({
                    method: 3079,
                    parameters: { prodgrp3_id: this.menu?.prodgrp3_id }
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([{
                    name: 'prodgrp3menu_new',
                    text: 'prodgrp3menu_new',
                    func: () => {
                        this.stateService?.go('prodgrp4', {
                            prodgrp3_id: this.menu?.prodgrp3_id,
                            prodgrp4_id: '+'
                        });
                    },
                    icon: 'fas fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                    translate: true
                }]);
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        await this.loadMenu();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    prodgrp2_id: number;
    prodgrp_name: string;
    prodgrp3_id: number;
    prodgrp3_name: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('prodGrp3Menu', {
//        templateUrl: 'views/components/views/prodGrp3Menu/prodGrp3Menu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'prodGrp3MenuService', 'ttGridFactory', function ($stateParams, stateService, prodGrp3MenuService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let prodGrp3Id = $stateParams.prodgrp3_id;

//            vm.model = {
//                menu: {},
//                gridReady: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_prodgrp3menu_prodgrp4_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setCustomToolbarButtons([{
//                    name: 'prodgrp3menu_new',
//                    text: 'prodgrp3menu_new',
//                    func: () => {
//                        stateService.go('prodgrp4', {
//                            prodgrp3_id: vm.model.menu.prodgrp3_id,
//                            prodgrp4_id: '+'
//                        });
//                    },
//                    icon: 'fa-plus',
//                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
//                    translate: true
//                }]);

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await prodGrp3MenuService.getMenu({ prodgrp3_id: prodGrp3Id }))[0];

//                loadGrid();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 3079,
//                    parameters: { prodgrp3_id: vm.model.menu.prodgrp3_id }
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMenu();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
